import React from 'react';
import { Box, CircularProgress } from '@mui/material';

function LoadingModalScreenContainer() {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 6 }}>
            <CircularProgress sx={{ color: '#c0392b' }} size={32} />
        </Box>
    );
}

export default LoadingModalScreenContainer;
